import { render, staticRenderFns } from "./SocialSignin.vue?vue&type=template&id=3514e9b6&scoped=true"
import script from "./SocialSignin.vue?vue&type=script&lang=ts"
export * from "./SocialSignin.vue?vue&type=script&lang=ts"
import style0 from "./SocialSignin.vue?vue&type=style&index=0&id=3514e9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3514e9b6",
  null
  
)

export default component.exports